import { Text } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';
import { device } from 'utils/device';

const FieldsGroup = styled.section`
    &:first-of-type {
        margin-top: 2.5rem;
    }
    &:not(:last-of-type) {
        margin-bottom: 4.5rem;

        @media ${device.maxTablet} {
            margin-bottom: 3.75rem;
        }
    }
`;

const GuardianCheckbox = styled.div`
    margin-top: ${rem(20)};
`;

const GroupTitle = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const InlineFields = styled.div<{ $template: string }>`
    display: grid;
    gap: 1rem;
    margin-top: 1.25rem;

    &:first-of-type {
        margin-top: 1rem;
    }

    input[type='number'] {
        appearance: textfield;
    }

    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        appearance: none;
    }

    @media ${device.minTablet} {
        grid-template-columns: ${({ $template }) => $template};
    }
`;

const SubmitButtonContainer = styled.div`
    margin: 3.75rem auto 0;
    max-width: 30rem;

    @media ${device.maxTablet} {
        margin: 2.25rem auto 0;
    }
`;

export { FieldsGroup, GuardianCheckbox, GroupTitle, InlineFields, SubmitButtonContainer };
